/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    countryId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Country
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    countryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    regionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    regionName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Country
     */
    regionEffective?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof Country
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof Country
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Country
     */
    updatedDate?: Date;
}

export function CountryFromJSON(json: any): Country {
    return CountryFromJSONTyped(json, false);
}

export function CountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Country {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryId': !exists(json, 'countryId') ? undefined : json['countryId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'countryName': !exists(json, 'countryName') ? undefined : json['countryName'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
        'regionName': !exists(json, 'regionName') ? undefined : json['regionName'],
        'regionEffective': !exists(json, 'regionEffective') ? undefined : json['regionEffective'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
    };
}

export function CountryToJSON(value?: Country | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryId': value.countryId,
        'allowEdit': value.allowEdit,
        'countryCode': value.countryCode,
        'countryName': value.countryName,
        'regionCode': value.regionCode,
        'regionName': value.regionName,
        'regionEffective': value.regionEffective,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
    };
}


